import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6d88efc5")

_pushScopeId("data-v-6d88efc5")
const _hoisted_1 = { class: "SendDateTimePeriod" }
const _hoisted_2 = { class: "SendDateTimePeriod__inner" }
const _hoisted_3 = { class: "inner__header" }
const _hoisted_4 = {
  key: 0,
  class: "header__title"
}
const _hoisted_5 = {
  key: 1,
  class: "header__title"
}
const _hoisted_6 = {
  key: 0,
  class: "inner__calendar"
}
const _hoisted_7 = { class: "calendar__col" }
const _hoisted_8 = {
  key: 0,
  class: "calendar__result"
}
const _hoisted_9 = { class: "result__date" }
const _hoisted_10 = { class: "result__number" }
const _hoisted_11 = { class: "result__month" }
const _hoisted_12 = {
  key: 0,
  class: "result__time"
}
const _hoisted_13 = {
  key: 1,
  class: "result__time"
}
const _hoisted_14 = {
  key: 2,
  class: "result__error"
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Подтвердить ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_close = _resolveComponent("icon-close")!
  const _component_s_calendar = _resolveComponent("s-calendar")!
  const _component_s_time = _resolveComponent("s-time")!
  const _component_s_button = _resolveComponent("s-button")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_ctx.isFTL)
          ? (_openBlock(), _createBlock("h2", _hoisted_4, "Выберите дату и время отправки"))
          : _createCommentVNode("", true),
        (_ctx.isLTL)
          ? (_openBlock(), _createBlock("h2", _hoisted_5, "Выберите дату и период отправки"))
          : _createCommentVNode("", true),
        (_ctx.isDateSelected)
          ? (_openBlock(), _createBlock(_component_icon_close, {
              key: 2,
              class: "header__close",
              onClick: _ctx.resetCalendar
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.opened)
        ? (_openBlock(), _createBlock("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_s_calendar, {
                class: { red: _ctx.isFTL, primary: _ctx.isLTL },
                "with-time": _ctx.isFTL,
                "with-periods": _ctx.isLTL,
                date: _ctx.activeState.send_date,
                "onUpdate:date": [
                  _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeState.send_date = $event)),
                  _ctx.onUpdateDate
                ],
                period: _ctx.activeState.send_period,
                "onUpdate:period": [
                  _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeState.send_period = $event)),
                  _ctx.onUpdatePeriod
                ]
              }, null, 8, ["class", "with-time", "with-periods", "date", "period", "onUpdate:period", "onUpdate:date"]),
              (_ctx.isFTL)
                ? (_openBlock(), _createBlock(_component_s_time, {
                    key: 0,
                    value: _ctx.activeState.send_time,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeState.send_time = $event)),
                    placeholder: "Время отправки",
                    ref: "sendTimeElement",
                    "is-invalid": _ctx.activeState.send_date && !_ctx.activeState.send_time
                  }, null, 8, ["value", "is-invalid"]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.isDateSelected)
              ? (_openBlock(), _createBlock("div", _hoisted_8, [
                  _createVNode("p", {
                    class: ["result__day", { red: _ctx.isFTL, primary: _ctx.isLTL }]
                  }, _toDisplayString(_ctx.getDayName(_ctx.activeState.send_date.getDay())), 3),
                  _createVNode("div", _hoisted_9, [
                    _createVNode("span", _hoisted_10, _toDisplayString(_ctx.activeState.send_date.getDate()), 1),
                    _createVNode("span", _hoisted_11, _toDisplayString(_ctx.getMonthName(_ctx.activeState.send_date.getMonth())), 1)
                  ]),
                  (_ctx.isFTL)
                    ? (_openBlock(), _createBlock("p", _hoisted_12, _toDisplayString(_ctx.activeState.send_time), 1))
                    : _createCommentVNode("", true),
                  (_ctx.isLTL)
                    ? (_openBlock(), _createBlock("p", _hoisted_13, _toDisplayString(_ctx.activeState.send_period
                                    ? _ctx.activeState.send_period.name
                                    : 'Период не указан'), 1))
                    : _createCommentVNode("", true),
                  (_ctx.activeState.send_date && !_ctx.state.is_can_submit)
                    ? (_openBlock(), _createBlock("p", _hoisted_14, " Вы не работаете в этот день. Вы уверены, что хотите выбрать эту дату? "))
                    : _createCommentVNode("", true),
                  _createVNode(_component_s_button, {
                    class: { red: _ctx.isFTL, primary: _ctx.isLTL },
                    disabled: 
                                (_ctx.isFTL && (!_ctx.activeState.send_date || !_ctx.activeState.send_time)) ||
                                (_ctx.isLTL && (!_ctx.activeState.send_date || !_ctx.activeState.send_period))
                            ,
                    onClick: _ctx.emitConfirm,
                    loading: _ctx.state.is_loading
                  }, {
                    default: _withId(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  }, 8, ["class", "disabled", "onClick", "loading"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
})